/**
 * Reads the JSON body of `/api/<platform>/get-profile`.
 *
 * The route answers HTTP 200 with the literal body `false` when the provider
 * chain finds no such account (StarAPI 404 / "Username doesn't exist"). Setup
 * used to treat that as a found profile (`false.error` is undefined), so a
 * customer could start a trial or pay for a handle that does not exist; the
 * server then could not create the account, the checkout stayed pending and
 * the Day-3 invoice was held forever with no charge (2026-10 incident).
 *
 * Returns the profile object to read fields from, or null when the account
 * was not found or the body carries an error.
 */
export function readFoundProfile(raw: unknown): Record<string, any> | null {
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null
    const body = raw as Record<string, any>
    if (body.error) return null
    const profile = body.graphql?.user || body.user || body
    if (!profile || typeof profile !== "object" || Array.isArray(profile)) return null
    return profile
}
